import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Preloader from 'components/common/Preloader/Preloader';
import { AppDispatch } from 'store/store';
import { resetPasswordThunk } from 'actions/authActions';

import { BackToLoginLink, EmailInput, Button } from '../common';
import { IForgotPasswordValue } from '../auth';
import { CardTitle, ForgotPasswordFormPosition, TextForgotPassword } from '../styles';

interface IForgotPasswordForm {
  onShowLinkIsSentContent: VoidFunction;
}

export const ForgotPasswordForm: React.FC<IForgotPasswordForm> = ({ onShowLinkIsSentContent }) => {
  const { t } = useTranslation();
  const dispatch: AppDispatch = useDispatch();
  const [resetPasswordError, setResetPasswordError] = useState();
  const [showSpinner, setShowSpinner] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { isValid, errors },
  } = useForm<IForgotPasswordValue>({ mode: 'onChange' });

  const onSubmit = useCallback(
    async (data: IForgotPasswordValue) => {
      setShowSpinner(true);
      const resetPasswordPassword = await dispatch(resetPasswordThunk(data));

      if (resetPasswordPassword.meta.requestStatus === 'fulfilled') {
        onShowLinkIsSentContent();
      } else if (resetPasswordPassword.payload.email) {
        const errorMessage = resetPasswordPassword.payload.email[0];

        if (errorMessage === 'Email not found') {
          onShowLinkIsSentContent();
        } else {
          setResetPasswordError(errorMessage);
        }
      }

      setShowSpinner(false);
    },
    [setShowSpinner, setResetPasswordError, dispatch, onShowLinkIsSentContent],
  );

  return (
    <>
      <ForgotPasswordFormPosition onSubmit={handleSubmit(onSubmit)}>
        <CardTitle>{t('components.resetPassword.title')}</CardTitle>
        <TextForgotPassword>{t('components.resetPassword.enterYourEmail')}</TextForgotPassword>
        <EmailInput
          label={t('components.login.email')}
          register={register}
          errorEmail={errors.email}
          resetPasswordError={resetPasswordError}
          autoComplete="on"
        />
        {showSpinner ? (
          <div style={{ marginTop: 'auto' }}>
            <Preloader />
          </div>
        ) : (
          <Button label={t('components.resetPassword.buttons.resetPassword')} disabled={!isValid} />
        )}
        {!showSpinner && <BackToLoginLink />}
      </ForgotPasswordFormPosition>
    </>
  );
};
